export class OptionState {
    options = [];
    constructor() {}
}

export default new OptionState();
